import styled from "styled-components"
import { theme } from "Theme"

export const Wrapper = styled.div`
  ${(props) => (props.background ? `background-image: url(${props.background});` : "")}
  ${(props) => (props.background ? `box-shadow: inset 0 120px 64px -64px #fff;` : "")}
${(props) =>
    props.background
      ? `background-repeat: no-repeat;background-size: cover;background-position: bottom;background-attachment: fixed;`
      : ""}
`

export const Content = styled.div`
  display: block;
  // padding: 4rem 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  overflow: visible;
  max-width: ${theme.layout.base};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  @media (min-width: ${theme.breakpoints.s}) {
    // padding: 4rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
export const Title = styled.h2`
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  overflow: hidden;
  color: inherit;
`
export const Subtitle = styled.p`
  color: inherit;
  font-weight: normal;
  max-width: ${theme.layout.blog};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: center;
`
